import React, { Component } from "react";
import { Row, Col, Button } from "reactstrap";
import { curdActions } from "../../reduxCURD/actions";
import _ from "lodash";
import "./styles.css";
import LocationsSelection from "./LocationsSelection";
import ThisTable from "../Common/ThisTable";
import { languageService } from "../../Language/language.service";
import { pencilSquare } from "react-icons-kit/fa/pencilSquare";
import SvgIcon from "react-icons-kit";
import { ToastService } from "../../utils/toastify";
import { getLocationAssignmentAssetTree } from "../../reduxRelated/actions/assetHelperAction";
import { getAppMockupsTypes } from "../../reduxRelated/actions/diagnosticsActions";
import { getInProgressMaintenance } from "../../reduxRelated/actions/journeyPlanHelperActions";
import { Modal } from "reactstrap";
import { MyButton } from "../Common/Forms/formsMiscItems";
import { ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { themeService } from "../../theme/service/activeTheme.service";
import { CommonModalStyle } from "../../style/basic/commonControls";
import { ModalStyles } from "../Common/styles.js";

import {
  arrayToTree,
  filterTreeByProperties,
  loadTreeObjects,
  TreeNode,
  findTreeNode,
  groupTreeNodeByProperty,
  treeToArray,
  treeToPropertiesObject,
  oneLayerTreeItemsToObjects,
} from "../../utils/treeData";

import { userListRequest } from "../../reduxRelated/actions/userActions";

import { CRUDFunction } from "../../reduxCURD/container";
import { USER_LOADING_START_ACTIONS, USER_LOADING_STOP_ACTIONS } from "../User/userUtils";

import SpinnerLoader from "../Common/SpinnerLoader";

class LocationAssignments extends Component {
  constructor(props) {
    super(props);

    this.state = {
      plannableLocations: null,
      searchStr: "",
      users: null,
      spinnerLoading: true,
      groupedLocations: null,
      selectedUser: null,
      isButtonDisabled: true,
      selectedLocations: { target: { name: "locationIds", value: [] } },
      applicationlookupss: null,
      page: 0,
      showModal: false,
      groupedMRs: null,
    };

    this.onLocationsListChange = this.onLocationsListChange.bind(this);
    this.setSelectedUser = this.setSelectedUser.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handlePageSave = this.handlePageSave.bind(this);

    this.columns = [
      {
        Header: languageService("Name"),
        accessor: "name",
        minWidth: 80,
      },
      {
        Header: languageService("Email"),
        accessor: "email",
      },

      { Header: languageService("Role"), accessor: "role", minWidth: 80 },
      {
        Header: languageService("Assigned Locations"),
        accessor: "assignedLocationsCount",
      },
    ];
  }

  componentDidMount() {
    this.props.getLocationAssignmentAssetTree();
    this.props.userListRequest();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.selectedLocations &&
      prevState.selectedLocations.target &&
      this.state.selectedLocations &&
      this.state.selectedLocations.target &&
      _.isEqual(prevState.selectedUser, this.state.selectedUser)
    ) {
      if (!_.isEqual(prevState.selectedLocations.target.value, this.state.selectedLocations.target.value)) {
        this.setState({
          isButtonDisabled: false,
        });
      }
    }

    if (
      this.props.assetHelperActionType === "GET_LOCATION_ASSIGNMENT_ASSET_TREE_SUCCESS" &&
      this.props.assetHelperActionType !== prevProps.assetHelperActionType
    ) {
      let assetTree = this.props.locationAssetTree.assetsTreeObj;
      if (assetTree) {
        let assetList = treeToPropertiesObject(assetTree);
        let plannableLocations = this.findPlannableLocations(assetTree, assetList);
        let groupedLocs = _.groupBy(plannableLocations, "locationName");

        let options = Object.keys(groupedLocs)
          .map((group) => {
            let option = {
              label: group,
              options: groupedLocs[group]
                .map((loc) => {
                  return { value: loc._id, label: `${loc.unitId}` };
                })
                .sort(this.sortLocations),
            };
            return option;
          })
          .sort(this.sortLocations);

        this.setState({
          plannableLocations: plannableLocations,
          groupedLocations: options,
        });
      }
    }

    if (prevProps.diagnosticsActionType !== this.props.diagnosticsActionType) {
      if (this.props.diagnosticsActionType === "GET_USERSLOCATIONS_SUCCESS") {
        let applicationlookupss = _.cloneDeep(this.props.userLocations);
        applicationlookupss = applicationlookupss.filter((a) => a.listName === "userLocations");

        this.setState({
          applicationlookupss: applicationlookupss,
        });

        if (this.props.userList.length > 0) {
          this.setUsers(this.props.userList, applicationlookupss);
          this.setState({ spinnerLoading: false });
        }
      }
    }

    if (prevProps.applicationlookupsActionType !== this.props.applicationlookupsActionType) {
      if (["APPLICATIONLOOKUPS_UPDATE_SUCCESS", "APPLICATIONLOOKUPS_CREATE_SUCCESS"].includes(this.props.applicationlookupsActionType)) {
        ToastService.Success(languageService("Location Updated Successfully"));
        this.props.getAppMockupsTypes("userLocations");

        this.setState({
          isButtonDisabled: true,
        });
      }
    }

    if (this.props.userActionType !== prevProps.userActionType) {
      if (USER_LOADING_START_ACTIONS.includes(this.props.userActionType)) {
        this.setState({ spinnerLoading: true });
      }

      if (USER_LOADING_STOP_ACTIONS.includes(this.props.userActionType)) {
        this.props.getAppMockupsTypes("userLocations");
      }
    }

    if (
      this.props.journeyPlanHelperActionType === "GET_IN_PROGRESS_MAINTENANCE_SUCCESS" &&
      this.props.journeyPlanHelperActionType !== prevProps.journeyPlanHelperActionType
    ) {
      if (this.props.inProgressMaintenances.length === 0) {
        this.handleSave();
      } else {
        let data = _.mapValues(_.groupBy(this.props.inProgressMaintenances, "lineName"), (items) =>
          _.groupBy(items, (item) => (item.planType === "" ? "Inspection" : item.planType)),
        );
        this.setState({
          groupedMRs: data,
          showModal: true,
        });
      }
    }
  }

  setUsers(users, applicationLookups) {
    let stateUsers = [];

    users.forEach((u) => {
      let foundUser = applicationLookups.find((a) => a.code === u.email);

      let role = "";
      if (Array.isArray(u.userGroupObj)) {
        let group = u.userGroupObj.find((g) => g._id === u.userGroup);
        if (group) {
          role = group.name;
        }
      }

      // if (role.toLowerCase() === "fra") {
      //   return;
      // }

      stateUsers.push({
        name: u.name,
        email: u.email,
        role: role,
        assignedLocations: foundUser ? [...foundUser.opt1.locationIds] : [],
        assignedLocationsCount: foundUser ? [...foundUser.opt1.locationIds].length : languageService("Not Configured"),
      });
    });

    this.setState({
      users: stateUsers,
    });
  }

  setSelectedUser(e, user) {
    this.setState({
      //if user is pressed first time then the componenet did update prev state function must not be called
      selectedUser: user.original,
      selectedLocations: { target: { name: "locationIds", value: user.original.assignedLocations } },
      isButtonDisabled: true,
    });
  }

  onLocationsListChange(selected) {
    let event = { target: { name: "locationIds", value: selected } };

    //console.log(event);
    this.setState({
      selectedLocations: event,
    });
    //this.changeHandler(event);
  }

  sortLocations(a, b) {
    if (a.label > b.label) {
      return 1;
    }
    if (b.label > a.label) {
      return -1;
    }
    return 0;
  }

  findPlannableLocations(assetTree, assetsList) {
    let locationsId = [];

    filterTreeByProperties(assetTree, { location: true, plannable: true }, locationsId);
    let plannableLocations = [];
    assetsList.forEach((asset) => {
      {
        let foundLocation = locationsId.find((l) => l === asset._id);
        foundLocation && plannableLocations.push(asset);
      }
    });

    return plannableLocations;
  }

  handlePageSave(page) {
    this.setState({
      page: page,
    });
  }

  handleChange() {
    let dataToSend = {
      userEmail: this.state.selectedUser.email,
      lineIDs: [],
    };
    if (this.state.selectedLocations && this.state.selectedLocations.target) {
      for (let p of this.state.plannableLocations) {
        let foundIndex = this.state.selectedLocations.target.value.findIndex((l) => l === p._id);
        if (foundIndex === -1) {
          dataToSend.lineIDs.push(p._id);
        }
      }
    }

    this.props.getInProgressMaintenance(JSON.stringify(dataToSend));
  }

  handleSave() {
    if (this.state.selectedLocations && this.state.selectedLocations.target) {
      let key = this.state.selectedLocations && this.state.selectedLocations.target.name;
      let value = this.state.selectedLocations && this.state.selectedLocations.target.value;

      let applicationlookupss = this.state.applicationlookupss;

      let found = applicationlookupss.find((a) => a.code === this.state.selectedUser.email);
      let dataObj = {};
      if (found) {
        found.opt1[key] = value;
      } else {
        dataObj = {
          tenantId: "ps19",
          listName: "userLocations",
          code: this.state.selectedUser.email,
          opt1: { [key]: value },
          opt2: "",
        };
      }

      if (found) {
        this.props.updateApplicationlookups(found);
      } else {
        this.props.createApplicationlookups(dataObj);
      }
    }
  }

  renderErrorData() {
    let data = Object.keys(this.state.groupedMRs).map((lineName) => {
      return (
        <React.Fragment key={lineName}>
          {/* Line Name Level */}
          <p style={{ marginBottom: "0px", fontSize: "14px", fontWeight: "bold" }}>{lineName}</p>
          <div style={{ paddingLeft: "10px" }}>
            {Object.keys(this.state.groupedMRs[lineName]).map((planType) => (
              <React.Fragment key={planType}>
                {/* Plan Type Level */}
                <p style={{ marginBottom: "0px", fontSize: "12px", fontWeight: "bold" }}>{planType}</p>
                <ul
                  style={{
                    listStyle: "none",
                    padding: "0px 0px 0px 10px",
                    marginBottom: "0px",
                    fontSize: "12px",
                  }}
                >
                  {this.state.groupedMRs[lineName][planType].map((obj, index) => (
                    <li key={index}>{obj.title}</li>
                  ))}
                </ul>
              </React.Fragment>
            ))}
          </div>
        </React.Fragment>
      );
    });

    return <div>{data}</div>;
  }

  render() {
    return (
      <React.Fragment>
        <SpinnerLoader spinnerLoading={this.state.spinnerLoading} />

        <Modal contentClassName={themeService({ retro: "retroModal" })} isOpen={this.state.showModal} style={{ maxWidth: "40vw" }}>
          <ModalHeader style={(ModalStyles.modalTitleStyle, themeService(CommonModalStyle.header))}>Error</ModalHeader>

          <ModalBody style={(ModalStyles.footerButtonsContainer, themeService(CommonModalStyle.body))}>
            <p style={{ color: "red" }}>
              {languageService(
                "Error un-assigning locations, as some work orders/inspections in these locations are still in progress for the selected user.",
              )}
              {languageService("Please complete all, and then retry.")}
              <br></br>
              {languageService("Details of in progress work orders/inspections are as below:")}
            </p>

            {this.state.groupedMRs && (
              <div
                style={{
                  backgroundColor: "white",
                  overflowY: "scroll",
                  padding: "5px 12px 5px 12px",
                  minHeight: "50vh",
                  maxHeight: "50vh",
                }}
              >
                {this.renderErrorData()}
              </div>
            )}
          </ModalBody>

          <ModalFooter style={(ModalStyles.footerButtonsContainer, themeService(CommonModalStyle.footer))}>
            <MyButton
              bsStyle="warning"
              onClick={() => {
                this.setState({ showModal: false, groupedMRs: null });
              }}
            >
              {languageService("Close")}
            </MyButton>
          </ModalFooter>
        </Modal>

        <div style={{ width: "100%", padding: "10px" }}>
          <div className="userAssignedLocations-main">
            {this.state.users && this.state.users.length !== 0 && (
              <div className="user-Area">
                <h4>{languageService("Users")}</h4>
                <ThisTable
                  tableColumns={this.columns}
                  tableData={this.state.users}
                  pageSize={15}
                  minRows={1}
                  pagination={true}
                  forDashboard={false}
                  handlePageChange={(page) => this.handlePageSave(page)}
                  page={this.state.page}
                  height={"auto"}
                  handleSelectedClick={this.setSelectedUser}
                  onClickSelect
                />
              </div>
            )}

            {this.state.selectedUser && (
              <div className="locationsSelect-area-wrapper">
                <h4>{languageService("Locations")}</h4>

                <LocationsSelection
                  options={this.state.groupedLocations}
                  onLocationChange={this.onLocationsListChange}
                  selected={this.state.selectedUser.assignedLocations}
                  className={"locationsSelect-area"}
                />
                <br></br>
                <div className="button-area">
                  <span>
                    <strong>{languageService("Note")} :</strong>
                    <small>
                      {" "}
                      {languageService('Any "Not Configured" user will by default be assigned to all locations unless explicitly changed')}
                    </small>
                  </span>

                  <button
                    onClick={() => {
                      this.handleChange();
                    }}
                    disabled={this.state.isButtonDisabled}
                  >
                    {languageService("Save")}
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const getAssets = curdActions.getAssets;

const getAssetTree = curdActions.getAssetTree;
const getJourneyPlans = curdActions.getJourneyPlans;
const getApplicationlookupss = curdActions.getApplicationlookupss;
const updateApplicationlookups = curdActions.updateApplicationlookups;
const deleteApplicationlookups = curdActions.deleteApplicationlookups;
const createApplicationlookups = curdActions.createApplicationlookups;

let variables = {
  assetReducer: { assets: [] },

  assetHelperReducer: {
    locationAssetTree: {},
  },

  userReducer: {
    userList: [],
    userDetail: null,
    userDetailActionType: null,
    userListByGroup: [],
    errorMessage: "",
  },

  applicationlookupsReducer: {
    applicationlookupss: [],
  },
  diagnosticsReducer: {
    userLocations: [],
  },

  journeyPlanHelperReducer: { inProgressMaintenances: [] },

  assetTreeReducer: {
    assetTree: null,
  },
};

let actionOptions = {
  create: true,
  update: true,
  read: true,
  delete: true,
  others: {
    getAssets,
    getAssetTree,
    userListRequest,
    getAppMockupsTypes,
    getLocationAssignmentAssetTree,
    getInProgressMaintenance,
    getJourneyPlans,
    getApplicationlookupss: getApplicationlookupss,
    updateApplicationlookups: updateApplicationlookups,
    deleteApplicationlookups: deleteApplicationlookups,
    createApplicationlookups: createApplicationlookups,
  },
};
let containerReducers = [
  "assetReducer",
  "assetHelperReducer",
  "applicationlookupsReducer",
  "userReducer",
  "diagnosticsReducer",
  "journeyPlanHelperReducer",
];
let LocationAssignmentsContainer = CRUDFunction(
  LocationAssignments,
  "locationAssignent",
  actionOptions,
  variables,
  containerReducers,
  "asset",
);
export default LocationAssignmentsContainer;



// WEBPACK FOOTER //
// ./src/components/LocationAssignments/LocationAssignments.jsx